import { ChangeDetectorRef, Directive } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';
import {
    SelectableDateType
} from 'apps/account/src/account-shared/modules/monthly-daterange-picker/enums/selecable-date-type.enum';
import { SelectMode } from 'apps/account/src/account-shared/modules/monthly-daterange-picker/enums/select-mode.enum';

@Directive()
export abstract class CalendarBase {
    public startDate: Date;
    public endDate: Date;
    public hoveredDate: Date;
    public focusDate: Date;

    selectMode: SelectMode;
    selectedMonths: Date[] = [];

    today = new Date();

    selectSingle: boolean = false;

    protected maxDate?: Date;
    protected minDate?: Date;

    datesDisabled = false;
    markDisabled: Function;

    constructor(public cdr: ChangeDetectorRef) {
    }

    abstract get selectableDateType()

    abstract onDatesSelected(): void

    public toDateFormat(date: Date | NgbDate): Date {
        return date instanceof Date ? date : DateUtils.ngbDateToDate(date);
    }

    public toNgbDateFormat(date: Date | NgbDate): NgbDate {
        return date instanceof Date ? DateUtils.dateToNgbDate(date) : date;
    }

    public onDateSelection(date: Date | NgbDate) {
        date = this.toDateFormat(date);

        if (this.selectMode == SelectMode.Month) {
            this.toggleMonthSelection(date);
            return;
        }

        if (!this.selectSingle && (!!this.startDate && DateUtils.isSame(this.startDate, date))) {
            return this.reset();
        }

        if ((!!this.endDate && DateUtils.isSame(this.endDate, date))) {
            return this.reset();
        }

        if (this.isBeforeStart(date)) {
            return;
        }

        if (this.selectableDateType === SelectableDateType.Start) {
            this.setStartDate(date);
        } else {
            this.setEndDate(date);
        }

        this.cdr.detectChanges();
    }



    isBeforeStart(date: Date) {
        return this.startDate && !this.endDate && DateUtils.isBefore(date, this.startDate)
    }


    setStartDate(date: Date) {
        this.startDate = date;
        this.endDate = undefined;
        this.disableDates();
    }

    setEndDate(date: Date) {
        this.endDate = date;
        this.onDatesSelected();
    }

    isFocused(date: Date): boolean {
        return DateUtils.isSame(date, this.focusDate);
    }

    reset(event?: Event) {
        this.startDate = undefined;
        this.endDate = undefined;
        this.focusDate = undefined;
        this.hoveredDate = undefined;
        this.selectedMonths = [];
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        this.enableDates();
        this.cdr.detectChanges();
    }

    disableDates() {
        this.datesDisabled = true;
        this.markDisabled = (ngbDate: NgbDate) => {
            if (!ngbDate) {
                return false;
            }

            const date = DateUtils.ngbDateToDate(ngbDate);

            if (this.startDate) {
                return DateUtils.isBefore(date, this.startDate);
            }

            return false;
        }
    }

    enableDates() {
        this.datesDisabled = false;
        this.markDisabled = (date: NgbDate) => false;
    }

    public toggleMonthSelection(date: Date | null) {}
}
